import React, { useState, useEffect } from "react";
import {
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  ListItem,
  List,
  ListItemText,
} from "@mui/material";

import SriyanshCardHeader from "../../components/CardHeader";
import apiClient from "../../BaseUrl/apiClient.js";
import TokenService from "../../service/TokenService";
import EncryptService from "../../service/EncryptionService";
import { useNavigate } from "react-router-dom";

function CreateConsignee() {
  const tokenServiceDetails = TokenService.getUserDetails();
  const logineuname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const [newConsigneeName, setnewConsigneeName] = useState("");
  const [newConsigneeCode, setnewConsigneeCode] = useState("");
  const [errors, setErrors] = useState({});
  const [consignees, setconsignees] = useState([]);

  const navigate = useNavigate();

  const handleClose = () => {
    navigate("../", { replace: true });
  };

  const fetchConsignees = async () => {
  try {
      const response = await apiClient.post("/ConsigneeList", {});
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  useEffect(() => {
    fetchConsignees();
  }, []);

  const handlenewConsigneeCodeChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Allow only numeric values
      setnewConsigneeCode(value);
    }
  };

  const InsertNewConsignee = async (e) => {
    e.preventDefault();

    // uname,passwrd,rights,newConsigneeName,email,mobile,cretedby,vip,

    let formErrors = {};
    if (!newConsigneeName) formErrors.name = "Consignee/Shop Name is required";
    if (!newConsigneeCode)
      formErrors.newConsigneeCode = "Consignee/Shop Code is required";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      apiClient
        .post("/newconsignee", {
          newConsigneeName,
          newConsigneeCode,
          cretedby: logineuname,
          vip: ip,
        })
        .then(function (response) {
          setErrors(response.data);

          setnewConsigneeName("");
          setnewConsigneeCode("");
        })
        .catch(function (error) {
          if (
            error.response.data &&
            error.response.data.code === "ER_DUP_ENTRY"
          ) {
            alert("Duplicate Consignee Not Allowed");
          }
        });
    }
  };

  return (
    <div>
      {/* <SriyanshCardHeader Title="Create New Consignee" /> */}
      <Card className="Formcard ">
      <div className="input-groupHeading">
      Create New Consignee

            </div>
        <CardContent>
          <div className="row">
          <div className="container">
            <div className="input-group">
              <TextField
                label="Enter New Consignee/Shop Code"
                size="small"
                variant="outlined"
                type="tel"
                value={newConsigneeCode}
                onChange={handlenewConsigneeCodeChange}
                fullWidth
                error={!!errors.newConsigneeCode}
                helperText={errors.newConsigneeCode}
                inputProps={{ maxLength: 5, pattern: "[0-9]*" }}
              />
            </div>
            <div className="input-group">
              <TextField
                label="Enter Consignee/Shop Name"
                size="small"
                variant="outlined"
                value={newConsigneeName}
                onChange={(e) => setnewConsigneeName(e.target.value.toUpperCase())}
                fullWidth
                error={!!errors.newConsigneeName}
                helperText={errors.newConsigneeName}
                inputProps={{ maxLength: 30 }}
              />
            </div>
          </div>

          <>
            <div
              className="container flex"
              style={{
                display: "flex",
                paddingLeft: "40px",
                paddingRight: "40px",
                justifyContent: "space-between", // Distributes space between items
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={InsertNewConsignee}
                title="Click for Data Entry"
              >
                Create Consignee
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>

          <div className="container">
            <div className="input-group" />
            {/* List 1: Available Consignees */}
            <div className="input-group">
              <Box
                sx={{
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: 2,
                  overflow: "auto",
                  maxHeight: 300, // Optional scrollable height
                }}
              >
                <Typography
                  variant="h6"
                  component="div"
                  sx={{
                    backgroundColor: "#f0f0f0",
                    padding: "8px",
                    borderBottom: "1px solid #ccc",
                    textAlign: "center",
                  }}
                >
                  Consignee List
                </Typography>
                <List>
                  {consignees.map((item) => (
                    <ListItem
                      key={item.ConsigneeCode}
                      button
                      // onClick={() => handleTransferToSelected(item)}
                    >
                      <ListItemText
                        primary={item.Shop}
                        secondary={item.ConsigneeCode}
                      />
                    </ListItem>
                  ))}
                </List>
              </Box>
            </div>
          </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default CreateConsignee;
